const initialState = {
  gettingInfo: true,
  initialPassengers: [],
  passengers: [],
  address: {},
  query: {},
  product: {},
  actualPassengerPosition: 0
}

export const SET_GETTING_INFO = 'SET_GETTING_INFO'
export const SET_INFO_PASSENGERS = 'SET_INFO_PASSENGERS'
export const SET_INFO_PASSENGER = 'SET_INFO_PASSENGER'
export const SET_INFO_PRODUCT = 'SET_INFO_PRODUCT'
export const SET_INFO_QUERY = 'SET_INFO_QUERY'
export const SET_INFO_ADDRESS = 'SET_INFO_ADDRESS'
export const SET_INFO_DATA = 'SET_INFO_DATA'
export const SET_INFO_ACTUAL_PASSENGER = 'SET_INFO_ACTUAL_PASSENGER'
export const RESET_INFO_PASSENGER = 'RESET_INFO_PASSENGER'
export const AUTOCOMPLETE_INFO_PASSENGERS = 'AUTOCOMPLETE_INFO_PASSENGERS'


export default function info(state = initialState, action) {
  switch (action.type) {
    case SET_GETTING_INFO: {
      const { gettingInfo } = action
      return Object.assign({}, state, { gettingInfo })
    }
    case SET_INFO_PASSENGERS: {
      const { passengers, initialPassengers } = action

      if (initialPassengers)
        return Object.assign({}, state, { initialPassengers: passengers, passengers })

      return Object.assign({}, state, { passengers })
    }
    case SET_INFO_PASSENGER: {
      const { passenger } = action

      if (!passenger) return state

      const passengers = [].concat(state.passengers)

      passengers[state.actualPassengerPosition] = passenger

      return Object.assign({}, state, { passengers })
    }
    case SET_INFO_DATA: {
      const { data } = action
      const { address, product, query } = data
      return Object.assign({}, state, { address, product, query })
    }
    case SET_INFO_ACTUAL_PASSENGER: {
      const { actualPassengerPosition } = action
      return Object.assign({}, state, { actualPassengerPosition })
    }
    case RESET_INFO_PASSENGER: {
      const { position } = action
      const passengers = [].concat(state.passengers)

      passengers[position] = state.initialPassengers

      return Object.assign({}, state, { passengers })
    }

    case AUTOCOMPLETE_INFO_PASSENGERS: {
      const { passengers } = action
      const apiPassengers = [].concat(passengers)
      const initialPassengers = [].concat(state.initialPassengers)

      const newPassengers = initialPassengers.reduce((acc, passenger) => {

        // First, we want the owner
        if (acc.length === 0) {
          const owner = apiPassengers.find(p => p.owner)

          if (owner) return acc.concat([owner])
        }

        // If is completed, return that
        if (passenger.passport)
          return acc.concat([passenger])

        const matchIndex = apiPassengers.findIndex(p => p.type === passenger.type && !acc.find(accp => accp.passport === p.passport));

        if (matchIndex !== -1)
          return acc.concat([apiPassengers[matchIndex]])
        else
          return acc.concat([passenger])
      }, [])

      return Object.assign({}, state, { passengers: newPassengers })
    }
    default: {
      return state
    }
  }
}